import React from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";

const StoreGeneralSettings = () => {
  return (
    <>
      <div className="hstack justify-content-between mb-2 pt-3 px-3 pb-1">
        <Form.Group>
          <h6 className="m-0 d-block">Store Address Settings</h6>
          <Form.Text style={{ fontSize: 12 }}>
            This is where your business is located. Tax rates nad shipping rates
            will use this address.
          </Form.Text>
        </Form.Group>
        <Button size="sm">Save</Button>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 175px)" }}>
        <div className="px-3 pb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <Form.Group className="mb-2">
                <Row className="g-2">
                  <Col xs={12}>
                    <Form.Label className="m-0">Address Line 1</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Street address, P.O. box, company name"
                      required
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Address Line 2</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Apartment, suite, unit, building, floor (optional)"
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Currency</Form.Label>
                    <InputGroup>
                      <InputGroup.Text style={{ fontSize: 13 }}>
                        <span>$</span>
                      </InputGroup.Text>
                      <Form.Select style={{ fontSize: 13 }}>
                        <option>USD</option>
                        <option>INR</option>
                      </Form.Select>
                    </InputGroup>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Country</Form.Label>
                    <Form.Control type="text" placeholder="Country" required />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">State / Province</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="State or province"
                      required
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">City</Form.Label>
                    <Form.Control type="text" placeholder="City" required />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Postal Code</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="ZIP / Postal code"
                      required
                    />
                  </Col>
                </Row>
              </Form.Group>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default StoreGeneralSettings;
